<app-view-title Title="" [isPrimaryColor]="true"></app-view-title>
<div class="view-content centered-view">
  <app-information-screen [centered]="true" [secondaryColor]="true"
                          primaryContent="{{ 'Intellitrailer.Rental.BookingUpdated.Ready' | translate : 'Your rent has been updated!' }}"
                          image="/assets/Images/big-checkbox-white.png">
  </app-information-screen>
</div>
<div class="view-actions">
  <button mat-raised-button color="accent" (click)="next()">{{ 'Intellitrailer.Navigation.Next' | translate : 'Next' }}</button>
</div>

